import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QrGenerator = ({ link, qrRef }) => {
  return (
    <div ref={qrRef} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <QRCodeCanvas value={link} size={120} style={{ height: '160px', width: '160px' }} />
    </div>
  );
};

export default QrGenerator;
